export enum ChatBotEventType {
  CHAT_BOT_CLOSE_EVENT = 'chat_bot_close_event',
  CHAT_BOT_ONBOARDING_COMPLETE = 'chat_bot_onboarding_complete',
  COPILOT_TRACKING_EVENT = 'copilot_tracking_event',
}
